import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'unistore/react'
import i18n from 'i18next'
import injectSheet from 'react-jss'
import cx from 'classnames'
import * as actions from '../helpers/actions.jsx'
import {Paperclip, Upload as UploadIcon} from '../Icons/index.jsx'

import {
  getInstantQuoteWords,
  removeInstantQuoteWords,
  getInstantQuoteWordsCreation,
} from '../Services/storage.jsx'
import Uploader from './Uploader.jsx'

class UploadInput extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    chooseFilesLabel: PropTypes.string.isRequired,
    chooseFilesLabelWithFiles: PropTypes.string,
    onChange: PropTypes.func,
    uploaderProps: PropTypes.object.isRequired,
    wordCountEnabled: PropTypes.bool, //whether wordcount is required on uploaded files
    // store props
    files: PropTypes.array.isRequired,
    wordCount: PropTypes.number.isRequired,
    uploaderIsVisible: PropTypes.bool.isRequired,
    // store actions
    setWordCount: PropTypes.func.isRequired,
    showUploader: PropTypes.func.isRequired,
    removeFiles: PropTypes.func,
  }

  static defaultProps = {
    wordCountEnabled: false,
    onChange: Function.prototype,
  }

  // tofix: this whole logic about quote values must be moved to store.js and with constants instead of hardcoded times
  // it's totally outta control now because it's split between app.js, here (new upload component), moze quote components, and the ONE-AND-ONLY domBridge! (which prefills values?! wtf)
  constructor(props) {
    super(props)
    const lastQuoteWords = getInstantQuoteWords()
    const lastQuoteWordsCreationTime = getInstantQuoteWordsCreation()

    this.state = {
      isNarrow:
        typeof window !== 'undefined' &&
        window.matchMedia('(max-width: 767px)').matches,
    }

    // purge words and files after 24h
    if (lastQuoteWords) {
      const secondsSinceLastQuote = Math.round(
        (Date.now() - new Date(lastQuoteWordsCreationTime)) / 1000,
      )


      // forget after 24h
      if (secondsSinceLastQuote > 24 * 3600) {
        removeInstantQuoteWords()
        props.removeFiles()
      }
      // remember last quote words
      else {
        setTimeout(() => props.setWordCount(lastQuoteWords), 250) // have this happen after InstantQuote.jsx constructor....
      }
    }
  }

  componentDidMount() {
    this.mediaQuery = window.matchMedia('(max-width: 767px)')
    this.handleMediaChange = (e) => this.setState({isNarrow: e.matches})
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.handleMediaChange)
    } else {
      this.mediaQuery.addListener(this.handleMediaChange)
    }
  }

  componentWillUnmount() {
    if (!this.mediaQuery) return
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.handleMediaChange)
    } else {
      this.mediaQuery.removeListener(this.handleMediaChange)
    }
  }

  showUploader = (show) => () => this.props.showUploader(show)

  setWordCount = (event) => this.props.setWordCount(event.target.value)

  render = () => {
    const {
      classes,
      className,
      label,
      placeholder,
      chooseFilesLabel,
      chooseFilesLabelWithFiles,
      uploaderProps,
      wordCountEnabled,
    } = this.props
    let {files} = this.props
    const {
      wordCount,
      uploaderIsVisible,
      uploaderProps: {contactForm},
    } = this.props
    const {showUploader, setWordCount} = this

    if (contactForm) files = files.filter((file) => file.fromContactForm)

    const filesCount = files.length
    const value = files.map((file) => file.url).join(',')

    const uploadOrEditFilesLabel =
      !chooseFilesLabelWithFiles || !files.length
        ? chooseFilesLabel
        : chooseFilesLabelWithFiles

    return (
      <>
        {wordCountEnabled ? (
          <div
            className={cx(
              'input-with-label__wrapper instant-quote-form__input',
              classes.root,
              className,
            )}
          >
            <label>{label}</label>
            <div className={'word-count-or-upload'}>
              <input
                type={'text'}
                placeholder={placeholder}
                value={wordCount}
                onChange={setWordCount}
              />
              <div
                className={cx(
                  'word-count-or-upload__upload',
                  classes.rightPart,
                )}
              >
                {!filesCount && (
                  <span className={'word-count-or-upload__or'}>
                    {i18n.t('Components.WordCountOrUpload.uploadFileOr')}
                  </span>
                )}
                {filesCount > 0 && (
                  <>
                    <Paperclip className={classes.filesNumberIcon} />
                    <p
                      className={cx(
                        classes.filesNumberText,
                        'word-count-or-upload__files-number',
                      )}
                    >
                      {`${filesCount} ${
                        filesCount === 1
                          ? i18n.t('Components.WordCountOrUpload.file')
                          : i18n.t('Components.WordCountOrUpload.files')
                      }`}
                    </p>
                  </>
                )}
                <div className={'word-count-or-upload__button-wrapper'}>
                  <button
                    type={'button'}
                    className={'button--compact button--secondary'}
                    onClick={showUploader(true)}
                    style={{
                      // Limited maxWidth to prevent Japanese text from overlapping the number
                      maxWidth: '120px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {uploadOrEditFilesLabel}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={cx(
              'word-count-or-upload word-count-or-upload--hide-words-count',
              classes.root,
              classes.wordCountDisabledRoot,
              className,
            )}
          >
            <label className={classes.wordCountDisabledLabel}>{label}</label>
            <div className={'word-count-or-upload__files-wrapper'}>
              <Paperclip />
              {!filesCount ? (
                <p className={'word-count-or-upload__files-number'}>
                  {i18n.t('Components.WordCountOrUpload.hideWordCountNoFiles')}
                </p>
              ) : (
                <p className={'word-count-or-upload__files-number'}>
                  {`${filesCount} ${
                    filesCount === 1
                      ? i18n.t('Components.WordCountOrUpload.file')
                      : i18n.t('Components.WordCountOrUpload.files')
                  }`}
                </p>
              )}
              <button
                type={'button'}
                onClick={showUploader(true)}
                className={'button--compact button--secondary upload-files-button'}
                style={
                  this.state.isNarrow
                    ? {
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minWidth: 0,
                        padding: '8px 10px',
                      }
                    : undefined
                }
              >
                {this.state.isNarrow ? (
                  <UploadIcon
                    className={'upload-files-button__icon'}
                    style={{
                      margin: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 20,
                      height: 20,
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  i18n.t('Components.WordCountOrUpload.hideWordUploadButton')
                )}
              </button>
            </div>
          </div>
        )}
        <input type={'hidden'} name={'files-hidden'} value={value} />
        {uploaderIsVisible && (
          <Uploader
            {...uploaderProps}
            wordCountEnabled={wordCountEnabled}
            modal={true}
          />
        )}
      </>
    )
  }
}

const Component = connect(
  ['files', 'wordCount', 'uploaderIsVisible'],
  actions,
)(UploadInput)

export default injectSheet({
  root: {
    marginRight: 0,
  },
  wordCountDisabledRoot: {
    marginBottom: 24,
  },
  wordCountDisabledLabel: {
    display: 'inline-block',
    alignSelf: 'flex-start',
    fontSize: 16,
    lineHeight: '24px',
    marginBottom: 8,
  },
  filesNumberIcon: {
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    fill: '#666',
    marginLeft: 6,
    marginRight: 6,
  },
  filesNumberText: {
    marginRight: 6,
  },
})(Component)
